<template>
  <div class="nav-list">
    <div class="item" v-for="(item, i) in navList" @click="toPage(item.path)" :key="i">
      <img :src="require('../../assets/mobile/icon/' + item.icon)" alt="">
      <p>{{lang === 'zh' ? item.title : item.enTitle}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavList",
  data() {
    return {
      navList: [
        {
          path: '/mobile/news',
          icon: '1.png',
          title: '论坛资讯',
          enTitle: 'News'
        }, {
          path: '/mobile/activity',
          icon: '2.png',
          title: '论坛活动',
          enTitle: 'Events'
        }, {
          path: '/mobile/result',
          icon: '3.png',
          title: '论坛成果',
          enTitle: 'Research '
        },
        {
          path: '/mobile/expert',
          icon: '4.png',
          title: '专家委员会',
          enTitle: 'Experts'
        }
      ],
    }
  },
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  },
  methods: {
    toPage(path) {
      const _path = this.lang === 'zh' ? path : '/us' + path;
      this.$router.push(_path);
      document.getElementById('app').scrollIntoView({ block: 'start' });
    }
  }
}
</script>

<style lang="less">
@import "../../common/theme";
@h-size-1: calc(@mobileFont * .55);
@h-size-2: calc(@mobileFont * .3);
@h-size-3: calc(@mobileFont * .61);
.mobile-home {
  .nav-list {
    display: flex;
    padding: 0 @h-size-1 @h-size-1;
    justify-content: space-between;
    align-items: center;
    img {
      width: @h-size-3;
      display: block;
      margin: 0 auto @h-size-2;
    }
  }
}
</style>
